import LogoWhite from 'assets/images/logo-white.svg'

import { SignUpHeaderWrapper } from './styled'

export function AuthHeader(): JSX.Element {
  return (
    <SignUpHeaderWrapper>
      <img src={LogoWhite} alt="Open Insurance" />
    </SignUpHeaderWrapper>
  )
}
